import script from "./EhTalkChat.vue?vue&type=script&setup=true&lang=js"
export * from "./EhTalkChat.vue?vue&type=script&setup=true&lang=js"

import "./EhTalkChat.vue?vue&type=style&index=0&id=7b6e4623&scoped=true&lang=css"

import exportComponent from "/home/nathan/Documentos/Creditall/Desenvolvimento/projetos/creditall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b6e4623"]])

export default __exports__